// @flow
import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import { withStyles } from '@material-ui/core/styles'
import * as colors from '../styles/colors'
import AnimationControls from './animation_controls'
import ButtonGroup from './buttongroup'
import type { AnalyzeFrameworkBarType } from '../reducers/analyze_framework_bar'
import type { SelectFrameworkBarType } from '../reducers/select_framework_bar'
import stylesFicus from '../styles'
import type { AnalysisPanelType } from '../reducers/analysis_panel'

type State = {
    message: string,
    animationOrder: string,
    helpDefault: boolean,
    helpValue: boolean,
    helpGrayswan: boolean,
    helpGrayswanValue: boolean,
    whichAnimationType: string,
}

export type Props = {
    addBookmark: Function,
    analysisPanel: AnalysisPanelType,
    classes?: {},
    config: AnalyzeFrameworkBarType,
    ficus: SelectFrameworkBarType,
    removeMapLocations: Function,
    setAnalyzeMode: Function,
    setConfig: Function,
    setFicusData: Function,
    theme: stylesFicus,
    updateIterationOrder: Function,
}

const styles = {
    help: {
        backgroundColor: 'rgba(0,0,0,0.03)',
        fontSize: 'smaller',
        padding: '5px',
    },

    helpIcon: {
        color: '#999999',
    },
}

class FicusControls extends React.Component<Props, State> {
    static defaultProps = {
        classes: {},
    }

    // eslint-disable-next-line react/sort-comp
    modeText: {} = {
        _allRealizations: 'Realizations',
        _quickOverview: 'Quartiles',
        _ranges: 'Others',
    }
    state: State = {
        message: '',
        animationOrder: 'default',
        helpDefault: true,
        helpGrayswan: true,
        helpGrayswanValue: true,
        helpValue: true,
        whichAnimationType: 'frame',
    }

    shouldComponentUpdate(nextProps: Props, nextState: State, nextContext) {
        return true || JSON.stringify(nextProps.config) !== JSON.stringify(this.props.config)
    }

    addMessage(message: string) {
        this.setState({ ...this.state, message })
    }

    removeMessage() {
        this.setState({ ...this.state, message: '' })
    }

    render() {
        const { classes } = this.props
        const animationClasses = [this.props.theme.animationButton]
        if (this.props.config.mode !== '_allRealizations') animationClasses.push(this.props.theme.disabled)

        const changeAnalyzeMode = (v) => {
            this.props.setConfig({ started: false })
            this.props.setAnalyzeMode(v)
        }

        const onChangeAnimationType = (e, value) => {
            if (this.props.config.mode === '_allRealizations') {
                this.props.updateIterationOrder(value)
            }
        }

        let buttons = []
        if (this.props.config.modes) {
            buttons = this.props.config.modes.map(m => ({ value: m, content: this.modeText[m], title: m }))
        }

        const hasValues = this.props.analysisPanel.analysisLocation && this.props.analysisPanel.analysisLocation.values.length > 0
        const hasValuesGrayswan = this.props.analysisPanel.analysisLocation && this.props.analysisPanel.analysisLocation.valuesGrayswan.length > 0

        const buttonStyle = {
            marginRight: '-10px',
        }
        const buttonEnabledStyle = {
            marginRight: '-10px',
            color: colors.secondaryTwo,
        }

        const updateHelp = (e, helpKey, newState) => {
            // this._dontUpdate = true
            e.preventDefault()
            this.setState({ ...this.state, [helpKey]: newState })
        }
        const realizationRadio = (key, keyText, helpKey, radioStyle, disabled) => (
            <FormControlLabel
                value={key}
                control={<Radio style={radioStyle} />}
                disabled={disabled}
                label={(
                    <span
                        style={{ width: '200px', display: 'inline-block' }}
                    >{keyText}
                        <span
                            className={`fa fa-question-circle-o ${this.props.theme.helpIcon}`}
                            onClick={e => updateHelp(e, helpKey, !this.state[helpKey])}
                            role="button"
                            style={{ float: 'right' }}
                            tabIndex="-1"
                        />
                    </span>
                )}
            />
        )
        const realizationHelp = (helpKey, text) => (
            <div
                className={this.props.theme.help}
                role="button"
                tabIndex="-1"
                onClick={e => updateHelp(e, helpKey, false)}
                style={{ marginRight: '10px' }}
            >{text}
            </div>
        )

        return (
            <div className={this.props.theme.top}>
                <div>
                    <div className={this.props.theme.toolbuttonPanel}>
                        <button
                            className={this.props.theme.toolbutton}
                            onClick={() => this.props.removeMapLocations()}
                            title="Remove all map popups"
                        >
                            <i className={'fa fa-trash'} />
                        </button>
                        <button
                            className={this.props.theme.toolbutton}
                            onClick={() => {
                                this.props.addBookmark('bookmarksLocal', this.props.ficus.ficusNode)
                                this.addMessage('Bookmark added')
                            }}
                            title="Add to Bookmarks"
                        >
                            <i className={'fa fa-bookmark'} />
                        </button>
                        <div className={this.props.theme.buttonGroup}>
                            <ButtonGroup
                                allowEmpty={false}
                                buttons={buttons}
                                enabled={!this.props.ficus.fetchingFicusData}
                                onChange={v => changeAnalyzeMode(v)}
                                theme={this.props.theme}
                                value={this.props.config.mode}
                            />
                        </div>
                    </div>

                    <AnimationControls config={this.props.config} ficus={this.props.ficus} setConfig={this.props.setConfig} theme={this.props.theme} />

                    {this.props.config.mode === '_allRealizations' && (
                        <div>
                            <div className={this.props.theme.ficusControlsHeader}>
                                <span className={this.props.theme.ficusControlsHeaderTitle}>Ordering</span>
                            </div>
                            <span style={{ display: 'inline-block', width: '20px' }} />
                            <RadioGroup
                                className={animationClasses.join(' ')}
                                name="iterationType"
                                style={{
                                    marginLeft: '40px',
                                    marginTop: '-20px',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-between',
                                    fontFamily: 'Roboto Condensed',
                                }}
                                value={this.props.config.iterationType}
                                onChange={onChangeAnimationType}
                            >
                                {realizationRadio('default', 'Default', 'helpDefault', buttonEnabledStyle, false)}
                                {this.state.helpDefault && realizationHelp('helpDefault', 'Realizations are ordered alphabetically by file name')}

                                {realizationRadio('grayswan', 'Gray Swan', 'helpGrayswan', buttonEnabledStyle, false)}
                                {this.state.helpGrayswan && realizationHelp('helpGrayswan', 'Realizations are ordered by global gray swan values')}

                                {realizationRadio('valueGrayswan', 'Grayswan at Location', 'helpGrayswanValue',
                                    hasValuesGrayswan ? buttonEnabledStyle : buttonStyle, !hasValuesGrayswan)}
                                {this.state.helpGrayswanValue && realizationHelp('helpGrayswanValue',
                                    'Realizations are ordered by local gray swan values' +
                                    (hasValuesGrayswan ? '' : '. Click on the map to select a location and click the "Realizations" button at the bottom of the popup that appears.'))}

                                {realizationRadio('value', 'Values at Location', 'helpValue', hasValues ? buttonEnabledStyle : buttonStyle, !hasValues)}
                                {this.state.helpValue && realizationHelp('helpValue',
                                    'Realizations are ordered from lowest values to highest values at the highlighted location' +
                                    (hasValues ? '' : '. Click on the map to select a location and click the "Realizations" button at the bottom of the popup that appears.'))}

                            </RadioGroup>
                        </div>
                    )}
                </div>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={4000}
                    message={this.state.message}
                    open={this.state.message !== ''}
                    onf={() => this.removeMessage()}
                    ContentProps={{ style: { backgroundColor: colors.secondaryOne } }}
                />
            </div>
        )
    }
}

export default withStyles(styles)(FicusControls)
